import { ReactNode, useEffect, useRef } from 'react';
import cx from 'classnames';
import { Icon, IconButton, Text } from '@intellecteu/common-ui';

import s from './styles.module.scss';

interface IPopup {
  overlayedItemId: string;
  closeFunction: (...args: any[]) => void;
  className?: string;
  children: ReactNode;
  title: string;
}

export const Popup = ({ overlayedItemId, closeFunction, className, children, title }: IPopup) => {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (ref.current && !ref.current.contains(event.target)) {
        closeFunction(event);
      }
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [closeFunction]);

  return (
    <div className={s.overlay}>
      <div id={overlayedItemId} className={cx(s.popup, className)} ref={ref}>
        <div className={s.popupClose}>
          <IconButton showHover onClick={closeFunction} iconName={Icon.icons.close} id={`close-popup__${title}`} />
        </div>

        <div className={s.popupContainer}>
          {title && (
            <Text className={s.popupContainerTitle} size={Text.size.xl} weight={Text.weight.bold}>
              {title}
            </Text>
          )}

          <div className={s.popupContainerBody}>{children}</div>
        </div>
      </div>
    </div>
  );
};
